module.exports = __webpack_public_path__ + "img/germany-tuberculosis-male.ed32c5f6.png";